import { render, staticRenderFns } from "./stakeholderPolicy.vue?vue&type=template&id=4e7e4012&scoped=true&"
import script from "./stakeholderPolicy.vue?vue&type=script&lang=js&"
export * from "./stakeholderPolicy.vue?vue&type=script&lang=js&"
import style0 from "./stakeholderPolicy.vue?vue&type=style&index=0&id=4e7e4012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7e4012",
  null
  
)

export default component.exports